










import { Component, Prop } from 'vue-property-decorator'
import { BaseInput, ICampoTemplate } from './base/BaseInput'

@Component({
  name: 'InputSwitch'
})
export default class InputSwitch extends BaseInput {
  @Prop({ required: true })
  campo!: ICampoTemplate
}
